<template>
    <div class="col-12 p-0 m-0 h-100 " v-if="notifications">
        <h3>Notifications</h3>
        <div class="scroll-panel">
            <div v-for="notification in notifications" :for="notification.id">
                <div v-if="notification.data.message" class="notification" :class="!notification.viewed_ts ? 'new' : ''">
                    <i class="fas" :class="iconType(notification.data.title)"></i> <span class="message" v-html="notification.data.message"></span><span class="timestamp">{{ notification.ts }}</span>
                </div>
            </div>
            <div class="mt-4 h-100 scroll-panel" v-if="notifications.length == 0">
                <div class="alert alert-warning text-center">No Notifications</div>
            </div>
            <div class="clearfix"></div>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Notifications',
    props: [
        'user',
        'limit'
    ],
    data() {
        return {
            notifications: []
        }
    },
    methods: {
        getNotifications() {
            let self = this;
            let limit = (self.limit != '' && self.limit != undefined ? '?limit=' + self.limit : '')
            axios.get("/api/users/" + self.user.id + "/notifications" + limit).then(response => {
                if (response.data && response.data.length !== '') {
                    self.notifications = response.data;

                    self.notifications.forEach(function (val, key) {
                        self.notifications[key].data = JSON.parse(val.data);
                    })

                }
            });
        },
        iconType: function (title) {

            if (title.indexOf('Survey') > -1) return 'fa-poll-h';
            if (title.indexOf('Kudos') > -1) return 'fa-star';
            if (title.indexOf('Winner') > -1) return 'fa-gift';

            return 'fa-exclamation-triangle';
        }
    },
    mounted() {
        let self = this;
        self.getNotifications();
    },
    created() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Notifications.vue